import { Component, OnInit } from '@angular/core';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { Title } from '@angular/platform-browser';
import { StaticModuleConsts } from '../../contants';
@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  private query: QueryRef<any>;
  firstSection: any;
  TERMS_OF_USE_QUERY = gql`
  query  {
    privacyPolicies{
      id
      heading
	  id
      content {
        raw
        
      }
    }
}
`;
  constructor(private apollo: Apollo, private statePersist: StatePersistService,
    private titleService: Title) { }

  ngOnInit(): void {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    this.titleService.setTitle(StaticModuleConsts.PRIVACY_POLICY_PAGE_TITLE);
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.query = this.apollo.watchQuery({
      query: this.TERMS_OF_USE_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.firstSection = result.data.privacyPolicies
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
      
    });
  }
  isFirstOpen = true;
  oneAtATime: boolean = true;
}
